var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isBingMapsOptions } from "../cesium";
import { FileLoader } from "../loaders";
import { isBingMapsCommonResponse } from "./BingMapsCommonResponse";
import { isBingMapsImageryMetadata } from "./BingMapsImageryMetadata";
import { BingMapsImageryProvider } from "../imagery/BingMapsImageryProvider";
/**
 *
 */
export class BingMapsImagerySet {
    /**
     * Async function that constructs a new BingMaps instance from the provided CesiumIonExternalAssetEndpoint endpoint
     * @param endpoint
     */
    static fromEndpoint(endpoint) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // A bunch of validation checks to ensure values are present
            if (typeof endpoint.externalType === "undefined")
                throw new Error("Missing endpoint.externalType");
            if (typeof endpoint.type === "undefined")
                throw new Error("Missing endpoint.type");
            if (typeof endpoint.options === "undefined")
                throw new Error("Missing endpoint.options");
            if (!isBingMapsOptions(endpoint.options))
                throw new Error("endpoint.options is not valid bing maps options");
            if (typeof endpoint.options.url === "undefined")
                throw new Error("Missing options.url");
            if (typeof endpoint.options.mapStyle === "undefined")
                throw new Error("Missing options.mapStyle");
            if (typeof endpoint.options.key === "undefined")
                throw new Error("Missing options.key");
            // Load the image metadata from the bing maps endpoint
            const options = endpoint.options;
            const metadataUrl = `${options.url}/REST/V1/Imagery/Metadata/${options.mapStyle}?output=json&include=ImageryProviders&key=${options.key}`;
            const response = yield FileLoader.loadJson(metadataUrl);
            // Check the response is matches the expected layout
            if (!isBingMapsCommonResponse(response))
                throw new Error("Invalid API response");
            // Check that the API has given us a response resource
            if (response.resourceSets.length === 0)
                throw new Error("No resource sets when there should be 1");
            if (response.resourceSets[0].resources.length === 0)
                throw new Error("No resources when there should be 1");
            // Check if the API has given us a valid metadata object
            const metadata = response.resourceSets[0].resources[0];
            if (!isBingMapsImageryMetadata(metadata))
                throw new Error("Invalid ImageryMetadata");
            if (metadata.imageUrlSubdomains === null)
                throw new Error("ImageryMetadata missing imageUrlSubdomains");
            if (metadata.imageUrl === null)
                throw new Error("ImageryMetadata missing imageUrl");
            // Create a copy of the metadata object and replace http:// urls with https://
            const fixedMetadata = Object.assign({}, metadata);
            if (fixedMetadata.imageUrl)
                fixedMetadata.imageUrl = fixedMetadata.imageUrl.replace("http://", "https://");
            return new BingMapsImagerySet(fixedMetadata, endpoint.options.url, endpoint.options.mapStyle, endpoint.options.key, (_a = endpoint.attributions) !== null && _a !== void 0 ? _a : []);
        });
    }
    /**
     *
     */
    createImageryProvider() {
        return new BingMapsImageryProvider(this.metadata, this.attributions);
    }
    constructor(metadata, url, mapStyle, key, attributions) {
        this.metadata = metadata;
        this.url = url;
        this.mapStyle = mapStyle;
        this.key = key;
        this.attributions = attributions;
    }
}
